import { render, staticRenderFns } from "./CommonAsides.vue?vue&type=template&id=1f98a666&"
import script from "./CommonAsides.vue?vue&type=script&lang=js&"
export * from "./CommonAsides.vue?vue&type=script&lang=js&"
import style0 from "./CommonAsides.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports